<div class="document-row">
    <a class="document-title" matTooltip="{{ title }}" matTooltipPosition="right"
        (click)="onclick.emit()" href="javascript:void(0)">
        <mat-icon svgIcon="folder_outline"></mat-icon>
        &nbsp;{{ title }}
    </a>
</div>